var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rr-scrollbar",class:{ vertical: _vm.vertical, horizontal: _vm.horizontal },on:{"mousedown":_vm.clickTrack}},[_c('div',{ref:"thumb",staticClass:"rr-scrollbar__thumb",style:(_vm.thumbStyle),on:{"mousedown":_vm.clickThumb}})])
}
var staticRenderFns = []

export { render, staticRenderFns }